module.exports = __webpack_public_path__ + "media/images/icons/cm-contact-form/whatever-71f600046e2ce78a6d89272fa04acc2f.svg";